module.exports = __webpack_public_path__ + "static/media/grand-canyon-usa.5818d7f7.jpg";